
import React from 'react';
import { Customer } from '@/lib/api/types';
import CustomerCard from './CustomerCard';

interface CustomerSelectionGridProps {
  customers: Array<Customer & { stats?: any }>;
  onSelectCustomer: (customer: Customer) => void;
  isLoading: boolean;
  loadingCustomerId: string | null;
  isLoadingStats: boolean;
  lastActiveCustomerId?: string;
}

const CustomerSelectionGrid: React.FC<CustomerSelectionGridProps> = ({
  customers,
  onSelectCustomer,
  isLoading,
  loadingCustomerId,
  isLoadingStats,
  lastActiveCustomerId
}) => {
  return (
    <div className="w-full flex justify-center">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl">
        {customers.map((customer) => (
          <div key={customer.id} className="w-full max-w-sm">
            <CustomerCard 
              customer={customer} 
              onSelect={onSelectCustomer}
              isLoading={isLoading && loadingCustomerId === customer.id}
              showStats={true}
              isLastActive={customer.id === lastActiveCustomerId}
            />
          </div>
        ))}
      </div>
      {isLoadingStats && (
        <div className="mt-8 text-center text-muted-foreground">
          <p className="text-sm">Loading customer statistics...</p>
        </div>
      )}
    </div>
  );
};

export default CustomerSelectionGrid;
